'use client';

import { useLocale } from 'next-intl';
import getOption from './getOption';

const currencies = {
  no: 'NOK',
  sv: 'SEK',
  de: 'EUR',
  pl: 'PLN',
  fi: 'EUR',
  en: 'EUR',
};

export default function useIfDefaultCurrency() {
  const locale = useLocale() as keyof typeof currencies;
  const defaultLocale = getOption('DEFAULT_LOCALE') as keyof typeof currencies;
  return currencies[locale] === currencies[defaultLocale];
}
